import type { ErrorContext } from 'react-oidc-context';

// The error react-oidc-context keeps for a failed navigator, as the Error to
// log: the oidc-client-ts error when there is one.
export const identityErrorCause = (
  error: ErrorContext | undefined
): Error | undefined => {
  if (error === undefined) {
    return undefined;
  }

  if (error.innerError instanceof Error) {
    return error.innerError;
  }

  const cause = new Error(error.message);
  cause.name = error.name;

  return cause;
};
